<script>
export default {
    props: {
        sliderImages: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            showSlider: false,
            sliderInitialImageIndex: 0,
        }
    },

    methods: {
        openSlider(imageUrl) {
            this.sliderInitialImageIndex = this.sliderImages.findIndex(
                ([url]) => url === imageUrl
            );
            this.showSlider = true;
            document.documentElement.style.overflow = "hidden";
        },
        closeSlider() {
            this.sliderInitialImageIndex = -1;
            this.showSlider = false;
            document.documentElement.style.overflow = "visible";
        }
    },
}
</script>
